// @flow
import {makeStyles} from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import {Link, Route, Switch, useLocation, useHistory} from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import {ButtonGroup, Grid, Hidden, IconButton} from '@material-ui/core';
import CustomButton from '../../elements/CustomButton/CustomButton';
import {
  ArrowBack,
  HelpTwoTone,
  InfoOutlined,
  PlayCircleFilledTwoTone,
  ConfirmationNumber,
  Textsms,
  Web,
} from '@material-ui/icons';
import {colors} from '../../assets/styles/colors';
import TemplatesContainer from './templates/container/TemplatesContainer';
// import ChatICon from '../../assets/img/chatIcon.png';
import DiscountIcon from '../../assets/img/discountIcon.png';

import AlertDueDateTier from '../tiers/components/AlertDueDateTier/AlertDueDateTier';

import ReviewsContainer from './reviews/containers/ReviewsContainer';
import CouponsContainer from './coupons/containers/CouponsContainer';
import PromotionsContainer from './promotions/containers/PromotionsContainer';
import {useIsFeatureInTier} from '../../utils/component';

import type {User, Store} from '../../entities';
import type {Node} from 'react';
import {TIENDADA_LINKS} from '../../constants/tiendada-links';
import {useIsMinimalPlan} from '../store/utils';
import PremiumFeatureBadge from '../../elements/PremiumFeatureBadge/PremiumFeatureBadge';
import {useMinimalTierContext} from '../../context/MinimalProvider';

type MarketingSubRoute = {
  name: string | Node,
  subtitle: string,
  showSubtitle: boolean,
  path: string,
  component?: Node,
  icon: Node,
  disabled?: boolean,
  tierRestricted?: boolean,
};

type Props = {
  store: Store,
  user: User,
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    background: '#f8f9fb',
  },
  navBackground: {
    [theme.breakpoints.down('sm')]: {
      background: 'white !important',
    },
  },
  icon: {
    height: '24px',
    width: '24px',
    marginRight: '8px',
    filter: 'brightness(0.5)',
  },
  content: {
    // flexGrow: 1,
    // paddingTop: 100,
    display: 'flex',
    flexDirection: 'column',
    // minHeight: '100%',
    // overflow: 'auto',
    padding: '.25rem',
    [theme.breakpoints.up('md')]: {
      padding: '1rem',
    },
  },
  dividerVertical: {
    margin: theme.spacing(0, 1),
    background: colors.grey300,
  },
  contentBottom: {
    // flexGrow: 1,
    // paddingTop: 100,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    // height: '100%',
    // marginBottom: 64,
    background: '#f8f9fb',
    // overflow: 'auto',
    padding: theme.spacing(0, 4),
    [theme.breakpoints.down('sm')]: {
      marginBottom: 140,
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 2),
    },
  },
  headerWrapper: {
    // background: '#f8f9fb',
    marginBottom: theme.spacing(2),
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'black',
  },
  ayudaButton: {
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '4px 13px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    margin: '0 14px 0 0',
    [theme.breakpoints.down('xs')]: {
      backgroundColor: 'unset',
      color: colors.purple3,
      fontSize: '12px',
      margin: '0 16px 0 0',
      padding: 0,
      boxShadow: 'unset',
    },
  },
  tutorialsButton: {
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '4px 13px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    [theme.breakpoints.down('xs')]: {
      backgroundColor: 'unset',
      color: colors.purple3,
      padding: 0,
      boxShadow: 'unset',
    },
  },
  subRouteHeader: {
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: theme.spacing(2),
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    // textAlign: 'left',
    // justifyContent: 'flex-start',
    backgroundColor: 'white',
    color: colors.grey800,
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
  },
  upsellMessage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      // flexDirection: 'column',
      padding: theme.spacing(1),
      flexWrap: 'wrap',
    },
    color: colors.purple3,
    background: colors.lightPurple,
    // opacity: 0.8,
    borderRadius: '12px',
    fontSize: '0.875rem',
  },
  upgradeTierButton: {
    marginLeft: 'auto',
    // backgroundColor: 'white',
    // color: colors.purple3,
    // padding: '4px 13px',
    // boxShadow:
    //   '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    backgroundColor: 'unset',
    color: colors.purple3,
    boxShadow: 'unset',
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(1),
      // backgroundColor: 'unset',
      // color: colors.purple3,
      // padding: 0,
      // boxShadow: 'unset',
    },
  },
  marketingButton: {
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '20px 20px',
    marginBottom: theme.spacing(2),
    textAlign: 'left',
    justifyContent: 'flex-start',
    backgroundColor: 'white',
    color: colors.grey800,
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
    whiteSpace: 'pre-wrap',
  },
  disabledMarketingButton: {
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '20px 20px',
    marginBottom: theme.spacing(2),
    textAlign: 'left',
    justifyContent: 'flex-start',
    backgroundColor: 'white',
    color: colors.grey800,
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
    whiteSpace: 'pre-wrap',
  },
  groupButton: {
    width: '100%',
    justifySelf: 'flex-end',
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '20px 20px',
    marginBottom: theme.spacing(2),
    // justifyContent: 'flex-start',
    border: 'none',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
  },
  subRouteIcon: {
    fontSize: '1.5rem !important',
    margin: '0 12px',
  },
  subRouteNameWrap: {
    height: 56,
    position: 'sticky',
    top: 72,
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    color: colors.grey700,
    backgroundColor: colors.grey200,
    padding: theme.spacing(2),
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
  subRouteNameText: {
    fontWeight: 600,
    fontSize: '1.125rem',
    color: colors.grey900,
  },
  subRouteContent: {
    borderRadius: '12px',
    overflow: 'hidden',
  },
  labelButton: {
    alignItems: 'center',
  },
  startIcon: {
    fontSize: '1.5rem !important',
    marginRight: 12,
  },
  upsellMessageBottom: {
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    maxWidth: 670,
    margin: theme.spacing(2),
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      position: 'fixed',
      bottom: 64,
      left: 0,
    },
    color: colors.purple3,
    background: colors.lightPurple,
    borderRadius: '12px',
    fontSize: '0.875rem',
  },
  subRouteSubtitle: {
    fontWeight: 400,
    fontSize: '16px',
    color: colors.grey600,
    margin: theme.spacing(1, 4),
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(2),
    },
  },
  subRouteTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  iconBack: {
    backgroundColor: 'white',
    padding: '4px',
    color: colors.grey600,
    marginRight: theme.spacing(1),
  },
}));

function getTutorialLinkByPathname(pathname: string) {
  if (pathname.includes('coupons')) {
    return TIENDADA_LINKS.tutorials.COUPONS;
  }

  if (pathname.includes('promotions')) {
    return TIENDADA_LINKS.tutorials.PROMOTIONS;
  }

  if (pathname.includes('reviews')) {
    return TIENDADA_LINKS.tutorials.REVIEWS;
  }

  if (pathname.includes('templates')) {
    return TIENDADA_LINKS.tutorials.TEMPLATES;
  }

  return TIENDADA_LINKS.customerSupport.general;
}

export default function Marketing(props: Props) {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();

  const isMinimal = useIsMinimalPlan();

  const {handleOpenRestriction} = useMinimalTierContext();

  const hasOrderReviewFeature = useIsFeatureInTier('ORDER_REVIEW');

  const subRoutes: {[key: string]: MarketingSubRoute} = {
    coupons: {
      name: (
        <div style={{display: 'flex', alignItems: 'center'}}>
          Cupones de descuento
          {isMinimal && (
            <div style={{display: 'flex', alignItems: 'center'}}>
              <PremiumFeatureBadge />
              <IconButton onClick={handleOpenRestriction}>
                <InfoOutlined />
              </IconButton>
            </div>
          )}
        </div>
      ),
      subtitle: 'Subtiutlo bla bla bla',
      path: '/marketing/coupons',
      component: <CouponsContainer />,
      icon: <ConfirmationNumber className={classes.startIcon} />,
      disabled: false,
      showSubtitle: false,
    },
    promotions: {
      name: (
        <div style={{display: 'flex', alignItems: 'center'}}>
          Promociones
          {isMinimal && (
            <div style={{display: 'flex', alignItems: 'center'}}>
              <PremiumFeatureBadge />
              <IconButton onClick={handleOpenRestriction}>
                <InfoOutlined />
              </IconButton>
            </div>
          )}
        </div>
      ),
      subtitle: 'Promociones',
      path: '/marketing/promotions',
      component: <PromotionsContainer />,
      icon: (
        <img src={DiscountIcon} alt="Promociones" className={classes.icon} />
      ),
      disabled: false,
      showSubtitle: false,
    },
    reviews: {
      show: hasOrderReviewFeature,
      name: 'Reseñas',
      subtitle:
        'Promueve tus ventas con el uso de las reseñas de cliente. No hay mejor recomendación que la de un cliente satisfecho.',
      path: '/marketing/reviews',
      component: <ReviewsContainer />,
      icon: <Textsms className={classes.startIcon} />,
      disabled: false,
      showSubtitle: true,
    },
    templates: {
      name: 'Plantillas',
      subtitle:
        'Te ayudamos a promocionar tu tienda, utiliza nuestras plantillas para promover tu tienda virtual en redes sociales. Descárgalas y compártelas en tus RRSS.',
      path: '/marketing/templates',
      component: <TemplatesContainer />,
      icon: <Web className={classes.startIcon} />,
      disabled: false,
      showSubtitle: true,
    },
  };

  const subRoutesArray = Object.keys(subRoutes).map(k => subRoutes[k]);

  const subRoute: ?MarketingSubRoute = subRoutesArray.find(
    (route: MarketingSubRoute) => location.pathname.startsWith(route.path)
  );

  const goPrevLocation = () => {
    history.goBack();
  };

  return (
    <div className={classes.root}>
      <AlertDueDateTier />
      <Hidden mdUp>
        {subRoute ? (
          <>
            <div className={classes.subRouteNameWrap}>
              <CustomButton to="/marketing" className={classes.iconBack}>
                <ArrowBack />
              </CustomButton>

              <Typography
                component={'span'}
                className={classes.subRouteNameText}
              >
                {subRoute.name} {subRoute.contentName}
              </Typography>
            </div>
            {subRoute.showSubtitle && (
              <span className={classes.subRouteSubtitle}>
                {subRoute.subtitle}
              </span>
            )}
          </>
        ) : (
          <div className={classes.subRouteNameWrap}>
            <CustomButton to="/tools">
              <ArrowBack />
            </CustomButton>
            <Typography component={'span'} className={classes.subRouteNameText}>
              Regresar
            </Typography>
          </div>
        )}
      </Hidden>

      <main className={classes.content}>
        <Hidden smDown>
          <div className={classes.headerWrapper}>
            <Grid container justify="space-between" alignItems="center">
              <Grid item style={{display: 'flex', gap: '1rem'}}>
                <CustomButton
                  onClick={goPrevLocation}
                  className={classes.iconBack}
                >
                  <ArrowBack />
                </CustomButton>
                {subRoute && subRoute.showSubtitle ? (
                  <Typography className={classes.title}>Marketing</Typography>
                ) : (
                  <Typography className={classes.title}>
                    {subRoute ? subRoute.name : ''}
                  </Typography>
                )}
              </Grid>
              <Grid item>
                <CustomButton
                  href={TIENDADA_LINKS.customerSupport.general}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.ayudaButton}
                  startIcon={<HelpTwoTone />}
                >
                  Ayuda
                </CustomButton>
                <CustomButton
                  href={getTutorialLinkByPathname(location.pathname)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.tutorialsButton}
                  startIcon={<PlayCircleFilledTwoTone />}
                >
                  Tutoriales
                </CustomButton>
              </Grid>
            </Grid>
            {subRoute && subRoute.showSubtitle && (
              <Grid container className={classes.subRouteHeader}>
                <Grid item className={classes.subRouteTitle} xs={12}>
                  {subRoute.icon} {subRoute.name}
                </Grid>
                {subRoute.subtitle && (
                  <Grid item className={classes.subRouteSubtitle} xs={12}>
                    {subRoute.subtitle}
                  </Grid>
                )}
              </Grid>
            )}
          </div>
        </Hidden>
        {subRoute && subRoute.tierRestricted && (
          <div className={classes.upsellMessage}>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <InfoOutlined style={{marginRight: 16}} />
              Suscríbete a nuestros planes para acceder a funcionalidades PRO e
              impulsar tu negocio
            </div>
            <CustomButton
              className={classes.upgradeTierButton}
              to="/tiers-list"
            >
              Mejorar Plan
            </CustomButton>
          </div>
        )}
        <Switch>
          <Route exact path="/marketing">
            <>
              {subRoutesArray.map((route: MarketingSubRoute, idx: number) => (
                <CustomButton
                  key={idx}
                  startIcon={route.icon}
                  disabled={route.disabled}
                  component={Link}
                  to={route.path}
                  classes={{
                    label: classes.labelButton,
                    startIcon: classes.startIcon,
                  }}
                  className={`${
                    route.disabled
                      ? classes.disabledMarketingButton
                      : classes.marketingButton
                  } `}
                >
                  {route.name}
                </CustomButton>
              ))}
            </>
          </Route>
          {subRoutesArray.map((route: MarketingSubRoute, idx: number) => (
            <Route key={`marketing-route-${idx}`} path={route.path}>
              <div className={classes.subRouteContent}>{route.component}</div>
            </Route>
          ))}
        </Switch>
      </main>
      <div className={classes.contentBottom}>
        <Hidden mdUp>
          <ButtonGroup>
            <CustomButton
              href={getTutorialLinkByPathname(location.pathname)}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.groupButton}
              startIcon={<PlayCircleFilledTwoTone />}
            >
              Tutoriales
            </CustomButton>
            <CustomButton
              href={TIENDADA_LINKS.customerSupport.general}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.groupButton}
              startIcon={<HelpTwoTone />}
            >
              Ayuda
            </CustomButton>
          </ButtonGroup>
        </Hidden>
      </div>
    </div>
  );
}

Marketing.propTypes = {
  store: PropTypes.object,
  user: PropTypes.object.isRequired,
};
